import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TERMS_META } from '../config/termsMeta';

// Renders nothing unless TERMS_META.pendingChange is set (see that file for when to set it).
// Dismissal is keyed by effectiveDate so a *new* pending change re-shows even if the user
// already dismissed a previous one.
const TermsUpdateBanner: React.FC = () => {
  const pending = TERMS_META.pendingChange;
  const storageKey = pending ? `luma_terms_notice_dismissed_${pending.effectiveDate}` : null;
  const [dismissed, setDismissed] = useState(
    () => !!storageKey && localStorage.getItem(storageKey) === '1'
  );

  if (!pending || dismissed) return null;

  const dismiss = () => {
    if (storageKey) localStorage.setItem(storageKey, '1');
    setDismissed(true);
  };

  // No outer `fixed` wrapper here — this renders as one card inside <NoticeBannerStack>,
  // which owns the shared fixed-bottom positioning so this can stack with other banners
  // (e.g. CookieBanner) instead of overlapping them.
  return (
    <div className="pointer-events-auto max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-2xl border border-amber-500/30 bg-zinc-950/95 backdrop-blur-xl px-5 py-4 shadow-2xl">
      <div className="flex-1 text-xs text-zinc-300 leading-relaxed">
        <span className="font-semibold text-amber-300">Terms update: </span>
        {pending.summary} Effective{' '}
        <span className="font-semibold text-white">{pending.effectiveDate}</span>.{' '}
        <Link to="/terms" className="text-white underline underline-offset-2 hover:text-zinc-300">
          Review changes
        </Link>
      </div>
      <button
        onClick={dismiss}
        className="shrink-0 px-4 py-2 rounded-full border border-white/10 text-zinc-400 text-xs font-bold hover:text-white hover:border-white/30 transition-colors"
      >
        Dismiss
      </button>
    </div>
  );
};

export default TermsUpdateBanner;
